<template lang="pug">
    v-card
        crud-data-table(
            no-data-text="Sin registros de pago de deudas."
            no-search
            no-remove
            remind-key='customer-receivable-payment-list'
            v-bind="tableProps"
            @detail="submitDetail"
            :no-actions="!$can('VIEW_DETAIL_RECEIVABLE_PAYMENT')"
            )
        crud-dialog( readonly submit-icon="print" submit-text="imprimir" title="detalles del registro de pago" v-model="dialog" @submit="submitDialog" )
            crud-form.elevation-0( no-buttons v-bind="formProps" style="min-height: 0%" )
                .my-5( slot="appendContent" )
                    crud-data-table.my-4( no-tools no-pagination no-actions v-bind="tablePaymentProps" v-model="tablePaymentProps.items")
                        h1( slot="prepend" ) ola
                    crud-data-table.my-4( no-tools no-pagination no-actions v-bind="tablePaymentsProps" v-model="tablePaymentsProps.items")
</template>

<script>
//
import { mapActions } from "vuex"
//
import { CrudForm } from "@/components/reusable_components"
import {
    CrudDialog,
    ModelDataTable,
} from "@/components/reusable_components/next"
//
import CustomerReceivablePaymentService from "@/services/api/pos/customer-receivable-payment"
import CustomerReceivablePaymentDetailService from "@/services/api/pos/customer-receivable-payment-detail"
import CustomerReceivablePaymentPaymentsService from "@/services/api/pos/customer-receivable-payment-payments"
//
import CustomerReceivablePaymentFilters from "./partials/CustomerReceivablePaymentFilters"
import CustomerReceivablePaymentHeaders from "./partials/CustomerReceivablePaymentHeaders"
//
export default {
    beforeMount() {
        this.setTitleTopBar("Registros de pago de deudas")
    },
    components: {
        "crud-data-table": ModelDataTable,
        "crud-dialog": CrudDialog,
        "crud-form": CrudForm,
    },
    computed: {
        /**
         *
         */
        formProps() {
            return {
                fields: this.fields,
            }
        },

        /**
         *
         */
        tableProps() {
            return {
                filters: CustomerReceivablePaymentFilters,
                headers: CustomerReceivablePaymentHeaders,
                service: CustomerReceivablePaymentService,
            }
        },

        /**
         *
         */
        tablePaymentProps() {
            return {
                headers: CustomerReceivablePaymentDetailService.headers,
                items: this.itemsPayment,
            }
        },

        /**
         *
         */
        tablePaymentsProps() {
            return {
                headers: CustomerReceivablePaymentPaymentsService.headers,
                items: this.itemsPayments,
            }
        },
    },
    data() {
        return {
            dialog: false,
            fields: CustomerReceivablePaymentService.fields,
            itemsPayment: [],
            itemsPayments: [],
            selected: null,
        }
    },
    methods: {
        /**
         *
         */
        ...mapActions("MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
        }),

        /**
         *
         */
        submitDetail(event) {
            //
            this.fields[0].value = event.item.id
            this.fields[1].value = event.item.sl_customer.business_name
            this.fields[2].value = [
                event.item.g_user.hr_employee.names,
                event.item.g_user.hr_employee.last_name1,
                event.item.g_user.hr_employee.last_name2,
            ].join(" ")
            this.fields[3].value =
                event.item.pos_cash_desk.g_branch_office.address

            //
            this.itemsPayment =
                event.item.pos_detail_customer_receivable_payments
            this.itemsPayments = event.item.transformed_payments.map(item => ({
                ...item,
                created_parent_at: event.item.created_at,
            }))

            //
            this.selected = event.item.id

            //
            this.fields = this.fields.slice()
            this.dialog = true
        },

        /**
         *
         */
        submitDialog() {
            CustomerReceivablePaymentService.print(this.selected)
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can("VIEW_ALL_RECEIVABLE_PAYMENT")) ctx.$router.push("/")
        })
    },
}
</script>